import React, { useEffect, useState } from "react";
import TmexPhoto from "../../assets/images/logo/header-typeface.png";
import { Link } from 'react-router-dom';
import "./Footer.scss";

export default function Footer() {
  const [whichActive, setWhichActive] = useState()
  useEffect(() => {
    let url = window.location.href.split('/')[4];

    switch (url) {
      case 'about':
        setWhichActive('about');
        break;
      case 'contact':
        setWhichActive('contact');
        break;
      case 'laws':
        setWhichActive('laws');
        break;
      case 'permission':
        setWhichActive('permission');
        break;
      case 'paytime':
        setWhichActive('paytime');
        break;
      case 'affiliate':
        setWhichActive('affiliate');
        break;
      default:
        setWhichActive('main')
    }
  }, [window.location.href]
  )

  return (
    <div className="footer-background">
      <div className="header">
        <img id="title" src={TmexPhoto} alt="logo" />
        <div className="items">
          <div className="d-none d-lg-flex items-container">
            <Link className={`${whichActive === 'main' ? 'active' : ''} `} to={'/'}>
              <h4>صفحه اصلی</h4>
            </Link>
            <Link className={`${whichActive === 'paytime' ? 'active' : ''} `} to={'/page/paytime/'}>
              <h4>زمان تسویه حساب</h4>
            </Link>
            <Link className={`${whichActive === 'permission' ? 'active' : ''} `} to={'/page/permission/'}>
              <h4>سطوح کاربری</h4>
            </Link>
            <Link className={`${whichActive === 'affiliate' ? 'active' : ''} `} to={'/page/affiliate/'}>
              <h4>کسب درآمد</h4>
            </Link>
            <Link className={`${whichActive === 'contact' ? 'active' : ''} `} to={'/page/contact/'}>
              <h4>ارتباط با ما</h4>
            </Link>
            <Link className={`${whichActive === 'about' ? 'active' : ''} `} to={'/page/about/'}>
              <h4>درباره ما</h4>
            </Link>
          </div>
        </div>
        <span id='spacer' />
        <div className="footer-icon">
          <i className="fab fa-facebook-f" />
          <i className="fab fa-twitter" />
          <i className="fab fa-linkedin-in" />
          <a target='_blank' href='https://www.instagram.com/temx_exchange/' className="fab fa-instagram" />
        </div>
      </div>
    </div>
  );
}
